import { formatErrorKeys } from '../../formatErrorKeys';
import { IdentificationValidationResult } from '../types';
import { validateUsername } from '../validateUsername';

export const validateUsernameForIdentification = async (username: string): Promise<IdentificationValidationResult> => {
    try {
        const response = await validateUsername(username);
        const formattedErrors = formatErrorKeys(response.data.errorKeys);

        if (formattedErrors.username?.includes('user_taken')) {
            return {
                exists: true,
                valid: true,
            };
        }

        return {
            exists: false,
            valid: response.data.status === 'success',
        };
    } catch (_error) {
        return {
            exists: false,
            valid: false,
        };
    }
};
